import { Component, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Eine Komponente, die die Benutzung der Filter-Elementen vereinfacht.
 * Die Komponente macht nichts, abgesehen von Darstellung und Optionale Filter aus- und einklappen.
 *
 * Verwendungsbeispiel:
 *
 * <common-filter-group>
 *     <div filter-main>
 *         // Mit Hilfe "filter-main" werden nicht ausklappbare Filtern definieren
 *          <common-filter-item label="Item 1">
 *            <common-form-range-number [min]="0" [max]="100"></common-form-range-number>
 *          </common-filter-item>
 *          <common-filter-item label="Item 2">
 *            <common-form-range-number [min]="0" [max]="100"></common-form-range-number>
 *          </common-filter-item>
 *     </div>
 *
 *     <div filter-optional>
 *         // Mit Hilfe "filter-optional" werden ausklappbare Filtern definieren
 *          <common-filter-item label="Item Optional 1">
 *           <common-form-range-number [min]="0" [max]="100"></common-form-range-number>
 *          </common-filter-item>
 *          <common-filter-item label="Item Optional 2">
 *           <common-form-range-number [min]="0" [max]="100"></common-form-range-number>
 *          </common-filter-item>
 *      </ng-container>
 *      <span filter-toggle-label>161 Produkte</span>
 *      <span filter-toggle-label>2 Filterkriterien gewählt</span>
 *      <span filter-toggle-icon ibtn="bin" ibtnUnboxed></span>
 *     </div>
 * </common-filter-group>
 */
@Component({
    selector: 'common-filter-group',
    templateUrl: 'filter-group.component.html'
})
export class FilterGroupComponent implements OnDestroy {

    /**
     * Ob die Optional-Fläche angezeigt wird.
     */
    @Input() optionalVisible = false;

    /**
     * Ob die Optional-Fläche als "nicht aktiv" angezeigt wird.
     */
    @Input() optionalDisabled = false;

    private ngUnsubscribe$: Subject<void> = new Subject<void>();


    ngOnDestroy(): void {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    toggleOptional() {
        this.optionalVisible = !this.optionalVisible;
    }
}
